/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import template from './workspace-widget-modal.component.html';

import {getAvailableWorkspaceWidgets, getWorkspaceWidgetTags} from './workspace-commons';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {APP_SHARED} from '../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-workspace-widget-modal',
  template
})
export class WorkspaceWidgetModalComponent implements OnInit {
  allWidgets: any[] = [];
  widgetsForShow: any[] = [];
  countWidgets = 0;
  tags: Record<string, number> = {};
  selectedTag: string;
  readonly onSaved = new Subject<any[]>();

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    this.allWidgets = getAvailableWorkspaceWidgets(this.LocalUserPermissions);
    this.widgetsForShow = this.allWidgets;
    this.countWidgets = _.size(this.allWidgets);
    this.tags = getWorkspaceWidgetTags(this.allWidgets);
  }

  filterTag(tag?: string): void {
    this.selectedTag = tag;
    if (!tag) {
      this.widgetsForShow = this.allWidgets;
      return;
    }
    this.widgetsForShow = _.filter(this.allWidgets, (widget) => _.indexOf(widget.systemDefined.tags, tag) > -1);
  }

  addWidget(widget: any): void {
    widget.added = !widget.added;
  }

  saveWidgets(): void {
    this.onSaved.next(_.filter(this.allWidgets, 'added'));
    this.bsModalRef.hide();
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
